module.exports = __webpack_public_path__ + "img/gnu_smart_gallery8.786f6052.jpg";